export default {
    data() {
        return {
            form: new Form(),
            update_route: null,
            create_route: null,
            base_route: null,
            resource_name: null,
            params: null,
        };
    },

    created() {
        if (!this.base_route && !this.update_route && !this.create_route) {
            throw new Error(
                `You must define one of the following data or properties in your form component to work properly:
                \n 'base_route',\n 'update_route',\n 'create_route'\n\n`
            );
        }

        if (!this.base_route && !this.resource_name) {
            throw new Error(
                `You must define one of the following data or properties in your form component to work properly:
                'base_route'
                'resource_name'`
            )
        }
    },

    computed: {
        resourceName() {
            if (this.base_route) {
                const names = this.base_route.split('.');
                return names[names.length];
            }

            return this.resource_name;
        },
    },

    methods: {
        setupForm(data = {}) {
            return this.form = new Form(data);
        },

        save() {
            const promise = this.form.id ? this.update() : this.create();
            return promise.then(response => {
                this.$emit('saved', { response, form: this.form });
                console.log('saved in the mixin');
                return response;
            })
        },

        update() {
            const update_route = this.update_route || `${this.base_route}.update`;
            return this.form.put(this.$laroute.route(update_route, { [this.resourceName]: this.form.id }))
                .then(response => {
                    this.$emit('updated', { response, form: this.form });
                    return response;
                })
        },

        create() {
            const create_route = this.create_route || `${this.base_route}.store`;
            return this.form.post(this.$laroute.route(create_route))
                .then(response => {
                    this.$emit('created', { response, form: this.form });
                    return response;
                });
        },
    }
}
